//src/pages/learner/learnerDetailsPage.js
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { checkEligibility } from '../../api/learner/learnerApi';
import useAuth from '../../hooks/useAuth';
import { v4 as uuidv4 } from 'uuid';

const LearnerDetailsPage = () => {
  const { user} = useAuth();
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const { projectId, projectCode } = location.state || {}; // Safeguard against undefined state

  const generateRandomEmail = () => {
    return `user_${uuidv4()}@myassessment.ai`;
  };

  useEffect(()=>{
    if(user?.email){
      setEmail(user?.email)
     };
    if(user?.fullName){
      setFullName(user?.fullName)
    }
  },[user])


  //console.log(user?.email, user?.fullName)
  //console.log('Project ID:', projectId); // Log to ensure data is passed

  if (!projectId) {
    return <div>Project ID is missing. Please try again.</div>;
  }
  
  const checkEligibilitys = async (finalEmail) => {
    try {
      const response = await checkEligibility(projectId, finalEmail, projectCode);
      if (!response.data.isEligible && response.data.attempt_status === "completed") {
        return false;
      }
      return true;
    } catch (error) {
      console.error('Eligibility check failed:', error);
      return false;
    }
    };

  const handleSubmit = async () => {
    const finalEmail = email.trim() ? email : generateRandomEmail();
    if (!validateEmail(finalEmail)) {
      alert('Invalid email format.');
      return;
    }
    const isEligible = await checkEligibilitys(finalEmail);
    if (isEligible) {
      navigate('/assessment', { state: { projectId, fullName, email: finalEmail, projectCode } });
    }
    else{
      alert("You have already reached the maximum number of attempts for this assessment.");
    }
  };
  
  const validateEmail = (email) => {
    // Regular expression to validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  
  
 return (
  <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-white to-[#eef1ff] px-4">
    
    <div className="w-full max-w-2xl bg-white rounded-2xl shadow-xl border border-[#e4e8ff] p-6 md:p-10 transition-all">

      
      <h2 className="text-xl md:text-3xl font-bold text-center text-[#36369f] mb-8">
        Your Assessment Details
      </h2>

      
      <div className="mb-6">
        <label className="block text-[#36369f] font-semibold mb-2">
          User Name
        </label>
        <input
          type="text"
          placeholder="Enter your name"
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
          readOnly={!!user?.fullName}
          className={`w-full px-4 py-3 rounded-xl border outline-none transition-all
            ${user?.fullName 
              ? "bg-gray-100 cursor-not-allowed" 
              : "bg-white focus:ring-2 focus:ring-[#36369f]"}
          `}
          style={{
            boxShadow:
              "inset 2px 2px 8px rgba(0,0,0,0.05), inset -2px -2px 8px rgba(255,255,255,0.8)",
          }}
        />
      </div>

      
      <div className="mb-8">
        <label className="block text-[#36369f] font-semibold mb-2">
          User Email ID
        </label>
        <input
          type="email"
          placeholder="Enter your email (optional)"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          readOnly={!!user?.email}
          className={`w-full px-4 py-3 rounded-xl border outline-none transition-all
            ${user?.email 
              ? "bg-gray-100 cursor-not-allowed" 
              : "bg-white focus:ring-2 focus:ring-[#36369f]"}
          `}
          style={{
            boxShadow:
              "inset 2px 2px 8px rgba(0,0,0,0.05), inset -2px -2px 8px rgba(255,255,255,0.8)",
          }}
        />
      </div>

      
      <div className="flex justify-center">
        <button
          onClick={handleSubmit}
          disabled={!fullName}
          className={`px-8 py-3 rounded-xl font-semibold text-white transition-all duration-300
            ${fullName
              ? "bg-[#36369f] hover:bg-[#2d2db3] shadow-lg hover:shadow-xl"
              : "bg-gray-400 cursor-not-allowed"}
          `}
        >
          Proceed to Assessment →
        </button>
      </div>

    </div>
  </div>
);
};

export default LearnerDetailsPage;